export default "__VITE_ASSET__DsgrBDNM__"